export default __webpack_public_path__ + "static/media/tour-e-agency-large.1839c055.png";